<template>
<div class="chapter">
<div class="inner_page">
<p class="C1177"><span id="page_17">P</span>ART ONE</p>
<p class="C1317">Framing Right and Wrong</p>
<p class="C1170">The construction of categories is the great beginning of moral teaching.</p>
<p class="C1170a"><span class="small">MARK D. JORDAN, <em>THE INVENTION OF SODOMY </em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_PART_ONE.vue?3f1db26a